var React = require('react');

function IconChat (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.3 22.5l-1.3-.75 3-5.25h4.5A1.5 1.5 0 0021 15V6a1.5 1.5 0 00-1.5-1.5h-15A1.5 1.5 0 003 6v9a1.5 1.5 0 001.5 1.5h6.75V18H4.5a3 3 0 01-3-3V6a3 3 0 013-3h15a3 3 0 013 3v9a3 3 0 01-3 3h-3.63l-2.56 4.5z","key":0}),React.createElement("path",{"d":"M6 7.5h12V9H6V7.5zM6 12h7.5v1.5H6V12z","key":1})]);
}

IconChat.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconChat;

IconChat.default = IconChat;
